import { InfoDialog } from "@/components/info-dialog"

type ModalInfoDocumentUploadedProps = {
  onClose: () => void
}

const ModalInfoDocumentUploaded = ({
  onClose,
}: ModalInfoDocumentUploadedProps) => {
  return (
    <InfoDialog
      titleLbl="Jumio.documentUploadedHeader"
      iconSrc={"/assets/dialog/success.svg"}
      bodyTitleLbl="Jumio.documentUploadedTitle"
      bodyTextLbl="Jumio.documentUploadedText"
      buttonLbl="Jumio.documentUploadedCta"
      onClick={onClose}
      handleClose={onClose}
    />
  )
}

export { ModalInfoDocumentUploaded }
